import IdeyaModal from '../../../../../common/antd/ideya-modal.tsx'
import {
  useGetDailyIdeaPnlQuery,
  useGetIdeaHistoryQuery,
} from '../../../../../apis/idea/idea-api.api.ts'
import { IdeaActionLog } from './idea-action-log.tsx'
import { IdeyaSpinner } from '../../../../../common/components/ideya-spinner.tsx'
import { IdeyaButton } from '../../../../../common/antd/ideya-button/ideya-button.tsx'
import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'

interface IdeaActionLogModalProps {
  showActionLogModal: boolean
  ideaId?: string | null
  handleCloseModal: () => void
  handleRefreshTable: () => void
}

export const IdeaActionLogModal: React.FC<IdeaActionLogModalProps> = ({
  showActionLogModal,
  ideaId,
  handleCloseModal,
  handleRefreshTable,
}) => {
  const { t } = useTranslation()
  const {
    currentData: historyData,
    isLoading: isLoadingHistory,
    isFetching: isFetchingHistory,
    refetch: refetchHistory,
  } = useGetIdeaHistoryQuery(ideaId ?? '', { skip: !ideaId })

  const {
    currentData: pnlData,
    isLoading: isLoadingPnl,
    isFetching: isFetchingPnl,
    refetch: refetchPnl,
  } = useGetDailyIdeaPnlQuery(ideaId ?? '', { skip: !ideaId })

  useEffect(() => {
    if (!showActionLogModal || !ideaId) return
    refetchHistory()
    refetchPnl()
  }, [showActionLogModal, ideaId, refetchHistory, refetchPnl])

  return (
    <IdeyaModal
      title={
        historyData
          ? historyData.data.idea.ticker.tickerCode +
            ' ' +
            historyData.data.idea.ticker.name
          : ''
      }
      open={showActionLogModal}
      width={900}
      onCancel={handleCloseModal}
      footer={
        <IdeyaButton onClick={handleCloseModal}>
          {t('common.got_it')}
        </IdeyaButton>
      }
    >
      {isLoadingHistory ||
      isFetchingHistory ||
      isLoadingPnl ||
      isFetchingPnl ? (
        <IdeyaSpinner />
      ) : historyData?.data && pnlData?.data ? (
        <IdeaActionLog
          actionLog={historyData.data}
          pnlData={pnlData.data}
          refetchData={() => {
            refetchHistory()
            refetchPnl()
            handleRefreshTable()
          }}
        />
      ) : null}
    </IdeyaModal>
  )
}
